import { forwardRef, useEffect, useRef } from "react";

export const Video = forwardRef((props, ref) => {
  const { srcObject, ...rest } = props;

  const localRef = useRef(null);
  const chosenRef = ref || localRef;

  useEffect(() => {
    if (!chosenRef.current) return;

    const videoElem = chosenRef.current;

    const startPlayingVideo = () => {
      videoElem.play().catch((e) => console.error("There was an error when trying to load the video:", e));
    };

    videoElem.oncanplay = startPlayingVideo;

    try {
      videoElem.srcObject = srcObject;
    } catch (e1) {
      try {
        videoElem.src = URL.createObjectURL(srcObject);
      } catch (e2) {
        console.error("Error attaching stream to element");
      }
    }

    return () => {
      videoElem.oncanplay = null;
      if (!chosenRef.current) return;

      try {
        chosenRef.current.srcObject = null;
      } catch (e1) {
        try {
          URL.revokeObjectURL(chosenRef.current.src);
          chosenRef.current.src = "";
        } catch (e2) {
          console.error("Error detaching stream from element");
        }
      }
    };
  }, [srcObject]);

  return <video ref={chosenRef} {...rest} autoPlay muted />;
});
